// extracted by mini-css-extract-plugin
module.exports = {"ul":"BulletedList_ul__R52d7"};